import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import InputBox from "../../Login/InputBox";

function BlueNavHeader({ label }) {
  return (
    <div
      className="sticky top-0 z-50 cursor-pointer"
      onClick={() => window.history.back()}
    >
      <div className="bg-eleghoBlue text-white flex items-center justify-start gap-4 h-12 w-full max-w-[450px] mx-auto">
        <div className="pl-4">
          <IoIosArrowBack />
        </div>
        <div>{label}</div>
      </div>
    </div>
  );
}

export default BlueNavHeader;